/*
 * Public API Surface of plugin-calendar
 */

export * from './lib/calendar.service';
export * from './lib/calendar.module';
